export default "__VITE_ASSET__VB89Zifv__"